import { IconCheck } from '@rossum/ui/icons/tabler';
import { Fade, Stack, SvgIcon, Typography } from '@rossum/ui/material';

type SuccessMessageProps = {
  message: string;
  show: boolean;
};

export const SuccessMessage = ({ message, show }: SuccessMessageProps) => {
  return (
    <Fade in={show}>
      <Stack flexDirection="row" alignItems="center" gap={0.5}>
        <SvgIcon color="success" fontSize="medium">
          <IconCheck />
        </SvgIcon>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Stack>
    </Fade>
  );
};
